import { createFileRoute } from '@tanstack/react-router';
import { VercelInstallPreviewDevRoute } from './-components';

export const Route = createFileRoute('/dev/vercel-install')({
  component: VercelInstallPreviewDevRoute,
});
